<template>
  <div>
    <Modal
      title="Logs da Integração "
      :active.sync="active"
      id="popup-integration-logs"
    >
      <vs-tabs alignment="center" v-model="activeTab">
        <vs-tab label="I4PRO" class="mt-4">
          <I4ProIntegrationContent
            :logs="syncI4ProLogs"
            :policy-id="policyId"
            @reload="getLogsI4Pro"
          />
        </vs-tab>
        <vs-tab label="STAR" class="mt-4">
          <StarIntegrationContent
            :logs="syncStarLogs"
            :policy-id="policyId"
            :policyType="policyType"
            :integrationsStatus="integrationsStatus"
            :paid-data="syncStarPaidInstallments"
            @reload="getLogsStar"
          />
        </vs-tab>
        <vs-tab label="Maxpar Vidros" class="mt-4">
          <MaxparIntegrationContent
            :logs="syncMaxparGlassLogs"
            :policy-id="policyId"
            :integrationsStatus="integrationsStatus"
            @reload="getLogsMaxparGlass"
          />
        </vs-tab>
        <vs-tab label="Maxpar Assistência" class="mt-4">
          <MaxparAssistanceIntegrationContent
            :logs="syncMaxparAssistanceLogs"
            :policy-id="policyId"
            :integrationsStatus="integrationsStatus"
            @reload="getLogsMaxparAssistance"
          />
        </vs-tab>
        <vs-tab label="Veniti" class="mt-4">
          <VenitiIntegrationContent
            :data="syncVenitiData"
            :policy-id="policyId"
            :reload="loadVenitiLogs"
          />
        </vs-tab>
      </vs-tabs>
    </Modal>
  </div>
</template>

<script>
import StarIntegrationContent from './contents/StarIntegrationContent';
import MaxparIntegrationContent from './contents/MaxparIntegrationContent.vue';
import MaxparAssistanceIntegrationContent from './contents/MaxparAssistanceIntegrationContent.vue';
import notify from '../../../utils/notify';
import VenitiIntegrationContent from './contents/VenitiIntegrationContent.vue';
import I4ProIntegrationContent from './contents/I4ProIntegrationContent.vue';
import venitiApiService from '../../../services/veniti.api';
import starApiService from '../../../services/star.api';
import maxparApiService from '../../../services/maxpar.api';
import i4proApiService from '../../../services/i4pro.api';
import Modal from '../../../components/Modal.vue';

export default {
  name: 'ModalIntegrationLogs',
  props: ['policyId', 'integrationsStatus', 'policyType'],
  components: {
    MaxparIntegrationContent,
    MaxparAssistanceIntegrationContent,
    VenitiIntegrationContent,
    StarIntegrationContent,
    I4ProIntegrationContent,
    Modal,
  },
  data() {
    return {
      active: false,
      activeTab: 0,
      syncStarLogs: [],
      syncStarPaidInstallments: { installments: [] },
      syncMaxparGlassLogs: [],
      syncMaxparAssistanceLogs: [],
      syncVenitiData: {},
      syncI4ProLogs: [],
    };
  },
  methods: {
    openModal() {
      this.getLogs();
      this.active = true;
    },
    async getLogs() {
      try {
        const [
          syncStar,
          syncMaxparGlass,
          syncMaxparAssistance,
          syncVeniti,
          syncI4Pro,
          starPaidInstallments,
        ] = await Promise.all([
          starApiService.getLogsByPolicyId(this.policyId),
          maxparApiService.getGlassLogsByPolicyId(this.policyId),
          maxparApiService.getAssistanceLogsByPolicyId(this.policyId),
          venitiApiService.getLogsByPolicyId(this.policyId),
          i4proApiService.getSyncLogs(this.policyId),
          starApiService.getPaidNonLooseInstallments(this.policyId),
        ]);
        this.syncStarLogs = syncStar;
        this.syncMaxparGlassLogs = syncMaxparGlass;
        this.syncMaxparAssistanceLogs = syncMaxparAssistance;
        this.syncVenitiData = syncVeniti;
        this.syncI4ProLogs = syncI4Pro;
        this.syncStarPaidInstallments = starPaidInstallments;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },

    async getLogsStar() {
      this.$vs.loading();
      try {
        const [logs, paid] = await Promise.all([
          starApiService.getLogsByPolicyId(this.policyId),
          starApiService.getPaidNonLooseInstallments(this.policyId),
        ]);
        this.syncStarLogs = logs;
        this.syncStarPaidInstallments = paid;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async getLogsMaxparGlass() {
      this.$vs.loading();
      try {
        this.syncMaxparGlassLogs =
          await maxparApiService.getGlassLogsByPolicyId(this.policyId);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async getLogsMaxparAssistance() {
      this.$vs.loading();
      try {
        this.syncMaxparAssistanceLogs =
          await maxparApiService.getAssistanceLogsByPolicyId(this.policyId);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async loadVenitiLogs() {
      this.$vs.loading();
      try {
        this.syncVenitiData = await venitiApiService.getLogsByPolicyId(
          this.policyId,
        );
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async getLogsI4Pro() {
      this.$vs.loading();
      try {
        this.syncI4ProLogs = await i4proApiService.getSyncLogs(this.policyId);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>

<style>
#popup-integration-logs.con-vs-popup .vs-popup {
  min-width: 960px;
}
</style>
